import { Icon, type IconName } from "@omnabase/ui";
import { useNavigate } from "react-router";
import { useNav, useWs } from "../lib/nav";
import { Shell } from "../shell/Shell";
import { AccountMenu } from "../shell/AccountMenu";
import { WorkspaceSwitcher } from "../shell/WorkspaceSwitcher";
import { useSession } from "../shell/store";

interface Row { id: string; label: string; icon: IconName; to: string; }
/** /more: the phone's fourth tab. Ported from the prototype's MoreScreen. Since the mobile polish round (2026-10-27): the person's own button at
 *  the top opens the account fly-out (profile, notifications, Away, Get help, the legal pages, Sign out: the "You" group and the last card went
 *  into it), the workspace button under it, then the workspace's groups, each heading above the card of its rows. */
export function MoreScreen() {
  const nav = useNav(); const navigate = useNavigate();
  const { ws } = useWs();
  const { me } = useSession();
  const WORKSPACE: Row[] = [
    { id: "customers", label: "Customers", icon: "users", to: ws("/customers?views=1") }, { id: "kb", label: "Knowledge base", icon: "book", to: ws("/knowledge?views=1") },
    { id: "reports", label: "Reports", icon: "chart", to: ws("/reports?views=1") }, { id: "settings", label: "Settings", icon: "settings", to: ws("/settings/general?views=1") },
  ];
  const row = (r: Row) => <a key={r.id} className="ob-views__item" href={r.to} onClick={(e) => nav(r.to, e)}><Icon name={r.icon} size="sm" /><span className="ob-views__text">{r.label}</span><Icon name="chevronRight" size="sm" className="ob-more__go" /></a>;
  return (
    <Shell crumbs={[{ label: "More" }]} bodyClassName="ob-body--full">
      <main className="ob-more" aria-label="More">
        <AccountMenu phone onContact={() => navigate(`${window.location.pathname}?help=contact`)} />
        <WorkspaceSwitcher phone />
        <nav className="ob-views ob-more__list" aria-label="More">
          <div className="ob-views__group"><div className="ob-views__label">Workspace</div><div className="ob-views__rows">{WORKSPACE.map(row)}</div></div>
          {me.platformAdmin && <div className="ob-views__group"><div className="ob-views__label">Platform</div><div className="ob-views__rows">{row({ id: "admin", label: "Admin", icon: "lock", to: "/admin" })}</div></div>}
        </nav>
      </main>
    </Shell>
  );
}
